"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_script_1 = require("./use-script");
exports.default = use_script_1.default;
//# sourceMappingURL=index.js.map